<section class="main-login col-12">
  <div class="login-box-wrap">
    <div class="login-box">

      <div class="login-box-header">
        <i [class._loading]="isLoading" [class._on-error]="hasError" [class._on-success]="isSuccess">
        </i>
      </div>

      <div *ngIf="!showForgotPassword()" class="login-header animated" [ngClass]="{'flipInY': true}">
        Customer Login
      </div>

      <div *ngIf="showForgotPassword()" class="forgot-password">
        <app-forgot-password (hideForgotPwd)="toggleForgotPassword()" [shownEmail]="email?.value || ''">
        </app-forgot-password>
      </div>

      <div *ngIf="!showForgotPassword()" class="login-body">
        <form [formGroup]="loginForm" (ngSubmit)="login()">
          <div class="form-group">
            <div class="input-group">
              <input type="email" class="form-control animated" formControlName="email" autofocus tabindex="1"
                placeholder="Email" [ngClass]="{
                  'flipInY': true, 
                  'err': email?.invalid && formSubmitted()
                }">
            </div>
          </div>

          <div class="form-group">
            <div class="input-group">
              <input type="password" class="form-control animated" formControlName="password" tabindex="2"
                placeholder="Password" [ngClass]="{
                  'flipInY': true, 
                  'err': password?.invalid && formSubmitted()
                }">
            </div>
          </div>

          <button class="btn login-button animated" type="submit" [class.onerror]="hasError"
            [ngClass]="{'flipInY': true}">
            <span>Login</span>
          </button>
        </form>
      </div>

      <div class='error-box-wrapper'>
        <div class='error-box animated' [class.flipInY]="true" *ngIf="hasError && errorMessage()">
          {{ errorMessage() }}
        </div>
      </div>

      <div class="login-footer animated" *ngIf="!showForgotPassword()">
        <a tabindex="3" class="login-link animated" (click)="toggleForgotPassword()"
          [ngClass]="{'flipInY': true}">
          Forgot Password?
        </a>
      </div>
    </div>
  </div>
</section>